<template>
    <defaultSec title="AI客服" id="ai" :isDisableScroll="true" class="ai-chat-wrap">
        <el-tabs v-model="activeName">
            <el-tab-pane label="AI互动" name="1">
                <section style="height: 100%">
                    <div class="qus-wrap" style="margin-bottom: 20px">
                        <el-input resize="none" :disabled="loading" type="textarea" :rows="3" v-model="inputValue" placeholder="请向我提问关于乐纯的问题吧"></el-input>
                        <div style="display: flex;justify-content: space-between">
                            <el-radio-group size="mini" v-model="chatType" style="display: block">
                                <el-radio-button label="coze">选择COZE模型</el-radio-button>
                                <el-radio-button label="dify">选择DIFY模型</el-radio-button>
                            </el-radio-group>
                            <el-button :disabled="loading" circle icon="el-icon-s-promotion" @click="getAnswer"></el-button>

                        </div>
                    </div>
                    <el-scrollbar class="scroll-wrap">
                        <div v-for="item in questionList">
                            <div class="item question">
                                <span class="icon el-icon-question"></span>
                                <p>{{item.question}}</p>
                            </div>
                            <div class="item answer">
                                <span class="icon icon-ans">{{item.type=='coze'?'C':'D'}}</span>
                                <template v-if="!item.answer">
                                    <p >
                                        <i class="el-icon-loading"></i>
                                    </p>
                                </template>
                                <template>
                                    <p class="ans-content" v-html="item.answer">
                                    </p>
                                </template>

                            </div>
                        </div>
                    </el-scrollbar>
                </section>
            </el-tab-pane>
            <el-tab-pane label="AI回复测试" name="2">
                <div style="margin-bottom: 10px">
                    <el-button type="danger" size="mini" @click="handleExecuteAll">一键测试所有问题</el-button>
                    <el-progress v-if="showProgress" :percentage="percentage"></el-progress>
                </div>
                <el-table :data="testQuesList" :height="tableHeight" border size="mini">
                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                    <el-table-column label="分类" prop="type" width="80"></el-table-column>
                    <el-table-column label="问题" min-width="230">
                        <template slot-scope="scope">
                            <div style="white-space: pre-line" v-html="scope.row.question">
                                {{scope.row.question}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="回复" prop="currentAnswer" min-width="230">
                        <template slot-scope="scope">
                            <div
                                :class="scope.row.currentAnswer?'text-scroll':''"
                                style="width: 100%;min-height: 50px;white-space: pre-line"
                                :style="{borderColor:scope.row.diff?'red':'#e5e5e5'}"
                                v-loading="scope.row.loading"
                                element-loading-text="拼命加载中"
                                element-loading-spinner="el-icon-loading"
                                element-loading-background="transparent"
                                v-html="scope.row.currentAnswer">
                                {{scope.row.currentAnswer}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="上次回复结果" min-width="230">
                        <template slot-scope="scope">
                            <div style="white-space: pre-line"
                                 :style="{borderColor:scope.row.diff?'red':'#e5e5e5'}"
                                 class="text-scroll" v-html="scope.row.answer">
                                {{scope.row.answer}}
                            </div>
                            <div style="text-align: right;margin-top: 5px">
                                {{scope.row.createTime}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="选项" prop="item" min-width="100"></el-table-column>
                    <el-table-column label="非标回复" min-width="230">
                        <template slot-scope="scope">
                            <div v-if="scope.row.keyword!=null" class="text-scroll" v-html="scope.row.keyword">
                                {{scope.row.keyword}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" width="100">
                        <template slot-scope="scope">
                            <el-button-group>
                                <el-button type="warning " size="mini"
                                           @click="handleSingleAnswer(scope.row)">AI回复

                                </el-button>
                            </el-button-group>
                        </template>
                    </el-table-column>
                </el-table>

            </el-tab-pane>
        </el-tabs>



    </defaultSec>
</template>

<script>
import defaultSec from '@c/defaultSection'

export default {
    name: "aiChatGPT",
    components:{defaultSec},
    data(){
        return {
            inputValue:'',
            questionList:[],
            loading:false,
            chatType:'coze',
            conversationCozeId:'',
            conversationDifyId:'',
            activeName:'1',
            testQuesList:[],
            percentage:0,
            successCount:0,
            showProgress:false,
            tableHeight:400
        }
    },
    mounted() {
        document.getElementById('ai').onkeydown = (e)=> {
            e = e || window.event;
            if(e.keyCode == 13) {
                this.getAnswer()
            }
        }
        //表格高度设置  -后面数字根据页面调整
        console.log('table',this.tableHeight)
        window.onresize = () => {
            console.log(document.querySelector('.default-body').offsetHeight)
            this.tableHeight = document.querySelector('.default-body').offsetHeight - 100
        }
        this.initAIAnswerList()
    },
    methods:{
        getAnswer(){
            if(!this.inputValue){
                this.$notify({
                    title: '警告',
                    message: '输入内容不能为空',
                    type: 'warning'
                });
                return false
            }
            this.loading = true
            this.questionList.unshift({question:this.inputValue,answer:'',type:this.chatType})
            this.inputValue = ''
            //https://gatewaytest.lechun.cc/lechun-ai/chat/stream?message=%E4%B9%90%E7%BA%AF%E6%9C%89%E5%93%AA%E4%BA%9B%E5%93%81%E7%B1%BB&chatId=&platformType=coze&conversationId=
            this.$apiGet('lechun-ai/chat/stream',{
                message:this.questionList[0].question,
                platformType:this.chatType,
                chatId:'',
                conversationId:this.chatType=='coze'?this.conversationCozeId:this.conversationDifyId
            }).then(res => {
                console.log(res)
                this.loading = false
                if(this.chatType=='coze'){
                    if(res.success){
                        let answerList = res.data.filter(item=>item.type=='answer')
                        answerList.map(item=>{
                            this.questionList[0].answer = item.content
                            this.conversationCozeId = item.conversation_id||''
                        })
                    }else{
                        this.questionList[0].answer = '服务器繁忙'
                    }
                }else {
                    this.questionList[0].answer = res.answer||'服务器繁忙，请重试'
                    this.conversationDifyId = res.conversation_id||''

                }


                // if(!res.err){
                //     this.questionList[0].answer = res
                // }
            }).catch((err)=>{
                this.loading = false
            })
        },
        initAIAnswerList(){
            this.$apiGet('lechun-ai/chat/getChatList',{ currentPage:1,pageSize:1000}).then(res => {
                console.log(res.dataList,res.dataList.list)
                this.tableHeight = document.querySelector('.default-body').offsetHeight - 100

                this.testQuesList = res.dataList&&res.dataList.list.map(item=>{
                    return{
                        ...item,
                        loading:false,
                        currentAnswer:'',
                        currentAnswerTime:'',
                    }
                })
            })
        },
        wait(ms) {
            return new Promise(resolve => {
                setTimeout(resolve, ms)
            });
        },
        async handleExecuteAll(){
            let int = null
            this.showProgress = true
            this.successCount = 0
            this.percentage = 0
            for (let i = 0; i < this.testQuesList.length; i++) {
                console.log(`开始第 ${i+1} 次循环，时间: ${new Date().toLocaleTimeString()}`);

                this.handleSingleAnswer( this.testQuesList[i])
                // 等待
                await new Promise(resolve => {
                    int = setTimeout(resolve, 3000)
                });
            }
            clearTimeout( int)
        },
        handleSingleAnswer(row){
                row.loading = true
                this.$set(row,'loading',true)
                if(row.currentAnswer){
                    this.$set(row,'answer',row.currentAnswer)
                    this.$set(row,'createTime',row.currentAnswerTime)
                    this.$set(row,'currentAnswer','')
                    this.$set(row,'currentAnswerTime','')
                }
                this.$apiGet('lechun-ai/chat/stream',{
                    message:row.question,
                    platformType:'dify',
                    chatId:row.toolsId,
                    conversationId:''
                }).then(res => {
                    this.successCount++
                    this.percentage = Math.floor(this.successCount/this.testQuesList.length*100)
                    this.$set(row,'currentAnswer',res.answer)
                    this.$set(row,'currentAnswerTime',new Date().Format('yyyy-MM-dd hh:mm:ss'))
                    this.$set(row,'loading',false)
                })

        }
    }
}
</script>

<style lang="scss" rel="stylesheet/scss">
.ai-chat-wrap{
    .qus-wrap{
        border: 1px solid #e5e5e5;
        background: #efefef;
        border-radius: 5px;
        padding: 10px;
        .el-textarea__inner{
            background: none;
            border: none;

        }
    }
    .text-scroll{
        border: 1px solid #e5e5e5;
        background: #efefef;
        border-radius: 5px;
        padding: 10px;
        white-space: pre-line;
        max-height: 230px;
        overflow-y: scroll
    }
    .ai-chat-wrap-table{
        height: calc(100% - 160px);
    }
    .scroll-wrap{
        height: calc(100% - 160px);
    }
    .item{
        display: flex;
        padding: 10px;
        margin: 20px 10px;
    }
    .answer{
        background: #efefef;
    }
    .img{
        width: 30px;
        height: 30px;
        margin-right: 20px;
        display: block;
    }
    p{
        flex: 1;
        margin: 0;
        span{
            white-space: pre-line;
        }

    }
    .icon{
        background: #f4d579;
        width: 30px;
        height: 30px;
        display: block;
        border-radius: 5px;
        color: #686868;
        font-size: 22px;
        text-align: center;
        line-height: 30px;
        margin-right: 20px;
    }
    .icon-ans{
        background: #209e91;
        color: #ffffff;
    }
    .ans-content{
        font-size: 14px;
        white-space: pre-line;
    }

}

</style>